/* 
 * ToggleButton.js
 * Created on 8-dec-2016
 * @author Swen Meeuwes for &ranj
 */


const ToggleButtonEvent = {};
export default ToggleButtonEvent;

ToggleButtonEvent.CLICK = "click";
